// extracted by mini-css-extract-plugin
module.exports = {"header":"AlertDialog_header__O1eJ3"};